<template>
    <div>
        <div class="calendar-flex">
            <label :for="id"></label>
            <input type="text" @input="validarFecha" ref="inputRef" @change="dateDefault" v-model="fecha" v-bind="$attrs" :aria-label="id"
                :id="id" :class="clases" @click="clickInput" :placeHolder="`${props.formato}`"
                autocomplete="off" />
            <img src="../../assets/calendar-green.png" class="icon-calendar-green" @click="clickIcon" alt="calendario"
                width="25" height="25" />
        </div>
        <div id="calendar" v-if="showCalendar" :class="positionClass">
            <div class="calendar-header">
                <div class="calendar-container-arrow">
                    <button @click.prevent="previousMonth" class="calendar-Arrow prevent"> &lt;</button>
                </div>
                <label :for="selectedMonth"></label>
                <select v-model="selectedMonth" :id="selectedMonth" @change="updateDatepicker" class="calendar-select" :aria-label="selectedMonth">
                    <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
                </select>
                <label :for="selectedYear"></label>               
                 <select v-model="selectedYear" :id="selectedYear" @change="updateDatepicker" class="calendar-select" :aria-label="selectedYear">
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <div class="calendar-container-arrow">
                    <button @click.prevent="nextMonth" class="calendar-Arrow prevent">&gt;</button>
                </div>
            </div>
            <div class="calendar-day">
                <div v-for="dia in week" :key="dia" class="calendar-week">{{ dia }}</div>
                <div v-for="day in days" :key="day" @click="selectedDateclick(day)" :id="day"
                    :class="{ 'selected': day === selectedDia && day !== '' }" class="day">{{ day }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, watch, onMounted, defineProps, computed } from 'vue';
const props = defineProps({
    position: { type: String, default: "bottom" },
    formato: { type: String, default: "YYYY/MM/DD" },
    showicon: { type: Boolean, default: true },
    today: { type: Boolean, default: false },
    id: { type: String, },
    icon: { type: String, },
    value: { type: String, },
    width: { type: String, }
});
const showCalendar = ref(false);
const date = ref(new Date().toISOString().substring(0, 10));
const selectedYear = ref(new Date().getFullYear());
const selectedMonth = ref(new Date().getMonth());
const years = Array.from({ length: 50 }, (_, i) => 2050 - i);
const week = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const days = ref([])
const selectedDia = ref("")
const inputRef = ref(null)
const fecha = ref(null);
const dateDefault = () => {
    if (props.today) {
        let formateando = date.value;
        formateando = formateando.replace(/-/g, "/");
        fecha.value = formateando;
    }
    else {
        fecha.value = ""
    }
    if (props.value) {
        fecha.value = props.value;
    }
}
const validarFecha = () => {
    const yyyymmdd = /^\d{4}\/\d{2}\/\d{2}$/;
    if (!yyyymmdd.test(inputRef.value)) {
        console.error(`El formato de fecha es invalido debe ser ${props.formato}`);
    }
}
const clickInput = () => {
    if (!props.showicon) {
        showCalendar.value = true;
    }
}
const clickIcon = () => {
    if (props.showicon) {
        showCalendar.value = true;
    }
}
const positionClass = computed(() => {
    return {
        [`${props.position === 'top' ? 'position-top' : 'position-bottom'} calendar`]: true
    }
});
const clases = computed(() => {
    return {
        [`calendar-width-${props.width}`]: true
    }
});
const updateDatepicker = () => {
    date.value = new Date(selectedYear.value, selectedMonth.value, 1).toISOString().substring(0, 10);
};
const selectedDateclick = (day) => {
    if (day === '') {
        return;
    }
    date.value = new Date(selectedYear.value, selectedMonth.value, day).toISOString().substring(0, 10);
    const fechaSeleccionada = document.getElementById(props.id)
    const captureFecha = date.value.split('')
    const formateandoFecha = `${captureFecha[0]}${captureFecha[1]}${captureFecha[2]}${captureFecha[3]}/${captureFecha[5]}${captureFecha[6]}/${captureFecha[8]}${captureFecha[9]}`;
    selectedDia.value = day
    fechaSeleccionada.value = formateandoFecha;
    fecha.value = formateandoFecha;
    showCalendar.value = false;
};
const previousMonth = () => {
    selectedMonth.value--;
    if (selectedMonth.value === -1) {
        selectedMonth.value = 11;
        selectedYear.value--;
    }
};
const nextMonth = () => {
    selectedMonth.value++;
    if (selectedMonth.value === 12) {
        selectedMonth.value = 0;
        selectedYear.value++;
    }
};
const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
};
const getFirstDayOfMonth = (selectedMonth, selectedYear) => {
    return new Date(selectedYear, selectedMonth, 1).getDay();
};
const generateCalendar = () => {
    days.value = []
    let firstDay = getFirstDayOfMonth(selectedMonth.value, selectedYear.value);
    for (let i = 0; i < firstDay; i++) {
        days.value.push('');
    }
    let daysInMonth = getDaysInMonth(selectedMonth.value, selectedYear.value);
    for (let i = 1; i <= daysInMonth; i++) {
        days.value.push(i);
    }
};
watch(selectedMonth, () => {
    generateCalendar();
});
watch(selectedYear, () => {
    generateCalendar();
});
onMounted(() => {
    generateCalendar();
    dateDefault();
});
</script>
<style scoped>
.calendar-flex {
    display: flex;
}

.calendar-day {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}

.day {
    text-align: center;
    border-radius: 4px;
    color: rgb(77, 77, 77);
    font-weight: bold;
    font-size: 13px;
}

.day:hover {
    background: #007A5E;
    cursor: pointer;
    color: white;
}

.day.selected {
    background-color: #007A5E;
    color: white;
}

.calendar-select {
    border: none;
    color: rgb(77, 77, 77);
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.calendar {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    position: absolute;
    z-index: 9999;
    display: block;
    background: white;
    padding: 0 15px 10px 15px;
    border: 1px solid #777;
}

.position-top {
    transform: translateY(-250px);
}

.calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    padding-inline: 5px;
    border-bottom: 1px solid black;
}

#calendar {
    width: 240px;
    height: auto;
    border-radius: 4px;
    box-shadow: 4px 4px 4px #777;
    border: 1px solid #777;
}

.calendar-opciones {
    display: flex;
    justify-content: center;
    gap: 1em;
    padding: 10px;
}

.calendar-opciones button {
    border: none;
    padding: 6px 6px;
    cursor: pointer;
}

#guardar:hover {
    background-color: #007A5E;
    color: white;
    border: none;
}

.calendar-Arrow {
    border-radius: 50%;
    border: none;
    cursor: pointer;
    background: #007A5E;
    color: white;
    font-weight: 700;
    font-size: 7px;
    padding: 2px 5px 2px 5px;
}

.calendar-container-arrow {
    display: flex;
}

.calendar-week {
    text-align: center;
    font-size: 13px;
}

.calendar-width-s {
    width: 100px;
}

.calendar-width-m {
    width: 18em;
}

.calendar-width-l {
    width: 24em;
}

.icon-calendar-green {
    padding: 0;
    cursor: pointer;
}
</style>